import { ENV } from "../Utils";

export class InstitutionApi {
  baseApi = ENV.BASE_API;

  async createInstitution(accessToken, formValue) {
    //console.log("formValue", formValue);
    try {
      const formData = new FormData();

      // Añadimos los datos comunes del usuario

      formData.append("avatar", formValue.fileAvatar);
      formData.append("firstname", formValue.firstname);
      formData.append("lastname", formValue.lastname);
      formData.append("email", formValue.email);
      formData.append("password", formValue.password);
      formData.append("role", formValue.role);
      formData.append("partnerId", formValue.partnerId);
      formData.append("active", false);
      // Datos adicionales específicos de la institución
      formData.append("institutionnam", formValue.institutionnam);
      formData.append("address", formValue.address);
      formData.append("city", formValue.city);
      formData.append("country", formValue.country);
      formData.append("phone", formValue.phone);
      formData.append("website", formValue.website);
      formData.append("planEducaId", formValue.planEducaId);
      formData.append("studentsnum", formValue.studentsnum);
      formData.append("teachersnum", formValue.teachersnum);

      // Agregamos idClient y active solo si están presentes
      if (formValue.idClient) {
        formData.append("idClient", formValue.idClient);
      }
      if (formValue.active !== undefined) {
        formData.append("active", formValue.active);
      }

      // Configuración de la solicitud
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/create`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      // Enviamos la solicitud
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message); // Manejo de error si no es 200 OK
      }

      return result; // Retorna el resultado en caso de éxito
    } catch (error) {
      console.error("Error en createInstitution:", error);
    }
  }

  async getInstitutions(accessToken, id, active = undefined) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/get/${id}/?active=${active}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }
  async getInstitutionsbyInstitution(accessToken, Id, active = undefined) {
    //console.log("Id",Id);
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTIONBYINSTITUTION}/get/${Id}/?active=${active}`;
      //console.log("url",url);
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }
  async updateInstitutionClassnumber(accessToken, idInstitution, userData) {
    try {
      let formData;
      // Si userData ya es instancia de FormData, úsala directamente
      if (userData instanceof FormData) {
        formData = userData;
      } else {
        formData = new FormData();
        // En caso de ser un objeto, lo procesarías aquí
        if (userData.classnumber && Array.isArray(userData.classnumber)) {
          userData.classnumber.forEach((item) => {
            formData.append("classnumber", item);
          });
        }
      }

      const url = `${ENV.BASE_API}/${ENV.API_ROUTES.INSTITUTION}/${idInstitution}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }
  async updateInstitution(accessToken, idInstitution, userData) {
    console.log("formValue", userData);
    try {
      const formValue = userData;
      const formData = new FormData();

      if (formValue.fileAvatar) formData.append("avatar", formValue.fileAvatar);
      if (formValue.firstname)
        formData.append("firstname", formValue.firstname);
      if (formValue.lastname) formData.append("lastname", formValue.lastname);
      if (formValue.email) formData.append("email", formValue.email);
      if (formValue.password) formData.append("password", formValue.password);
      if (formValue.role) formData.append("role", formValue.role);
      if (formValue.partner) formData.append("partnerId", formValue.partnerId);
      if (formValue.institutionnam)
        formData.append("institutionnam", formValue.institutionnam);
      if (formValue.address) formData.append("address", formValue.address);
      if (formValue.city) formData.append("city", formValue.city);
      if (formValue.country) formData.append("country", formValue.country);
      if (formValue.phone) formData.append("phone", formValue.phone);
      if (formValue.website) formData.append("website", formValue.website);
      if (formValue.plan) formData.append("plan", formValue.plan);
      if (formValue.studentsnum)
        formData.append("studentsnum", formValue.studentsnum);
      if (formValue.teachersnum)
        formData.append("teachersnum", formValue.teachersnum);

      const url = `${ENV.BASE_API}/${ENV.API_ROUTES.INSTITUTION}/${idInstitution}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }
  async toggleInstitutionActivation(accessToken, institutionId, active) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/activation/${institutionId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ active }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.error("Error in toggleInstitutionActivation:", error);
      throw error;
    }
  }
  async updateInstitutionActive(accessToken, idInstitution, institutionData) {
    try {
      const url = `${ENV.BASE_API}/${ENV.API_ROUTES.INSTITUTION}/${idInstitution}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json", // Añadir el Content-Type correcto
        },
        body: JSON.stringify(institutionData),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteInstitution(accessToken, idInsitution) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/${idInsitution}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteAvatar(accessToken, avatarUrl) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/delete-avatar`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ avatarUrl }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }
  async deleteClassNumber(accessToken, institutionId, classNumber) {
    try {
      // Construimos la URL con institutionId
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/${institutionId}/delete-class`;

      // Configuramos la petición DELETE con body en formato JSON
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ classNumber }), // lo que tu controlador espera en req.body
      };

      // Hacemos la petición
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message || "Error eliminando la classnumber");
      }

      return result; // Retorna la respuesta si todo va bien
    } catch (error) {
      console.error("Error en deleteClassNumber:", error);
      throw error;
    }
  }
}
